/**
* Crating
*/

const Crate = {
  cratingID: '#crating',
  cartURL: '/cart.json',
  updateURL: '/cart/update.js',
  changeURL: '/cart/change.js',
  cartPage: '/cart',

  headers_get: { method: 'GET', headers: { credentials: 'same-origin', "Content-Type": "application/json" }},
  headers_post: { method: 'POST', headers: { credentials: 'same-origin', "Content-Type": "application/json" }},

  crating: function(cart) {

    // remove existing crate
    // $.each(cart.items, function(key, value){
    //   if (value.title.toLowerCase().indexOf("crating") > -1) {
    //     Shopify.Cart.Crate.remove({[value.id]: 0});
    //   }
    // });
    
    // var cartID = 0;
    // $.ajax({url: "/cart", type: 'GET', async: false}).done(function(data){
    //   cartID = $(data).find('[name="attributes[crating]"').data("crate");

    //   let crateAmount = $(data).find(".crating-amount").text();
    //   $(".crating-amount").empty().text(crateAmount);

    //   // let crateId = $(data).find('[name="attributes[crating]"]').data("crate-id");
    //   // $('[name="attributes[crating]"]', window.document).data("crate-id", crateId);
    //   // window.ciid = crateId; 
    // });
    
    // return cartID;
  },

  getCrate: function(){
    var cartID = 0;
    var crateAmount;

    $.ajax({url: "/cart", type: 'GET', async: false}).done(function(data){
      let crateID = $(data).find('[name="attributes[crating]"]');

      // Update new crating ID
      cartID = crateID.data("crate-id");

      // update crate amount
      crateAmount = $(data).find(".crating-amount").text();
      $(".crating-amount").empty().text(crateAmount);
    });

    let crateChk = document.querySelector('#crating');
    if (crateChk != null || crateChk != undefined)
        crateChk.setAttribute("data-crate-id", cartID);

    return cartID;
  },
  
  update: async function(param) {
    // show modal
    $(".modal .modal-close").css({"display": "none"});
    $(".modal .modal-inner").css({"width": "320px", "white-space": "normal"});
    $(".modal .modal-content").html('<h5 class="text-center">Please wait while your cart is updating...</h5>');
    $(".modal").show();

    // get current cart
    let cart = await this.get();

    // Crate
    let hasCrate = false;
    let deleteCrate = { "updates": {} };
    
    // Collect cart crate item
    $.each(cart.items, async function(index, item){
      if (item.title.toLowerCase().indexOf('crating') > -1) {
        console.log("DELETE CRATE: ", item.id);
        deleteCrate.updates[item.id] = 0;
        hasCrate = true;
      }
    });

    // delete existing crate
    if (deleteCrate) await Crate.removeItem(deleteCrate);

    // Update the crating price
    let updateCratePrice = await Crate.getCrate();

    if (param.action == 'reload') {
      location.reload();
    } else {
      $(".modal .modal-close").css({"display": "block"});
      $(".modal .modal-inner").css({"width": "auto", "white-space": "nowrap"});
      $(".modal .modal-content").empty();
      $(".modal").hide();
    }
  },

  get: async function() {
    let data = await fetch(this.cartURL, this.headers_get)
                .then(data => data.json())
                .then(result => result);
    return data;

  },

  addItem: async function(id) {
    return await fetch(`${this.updateURL}`, {
                ...this.headers_post,
                body: JSON.stringify({ updates: { [id]: 1 }, attributes: { 'crating': true } })
              })
              .then(data => data.json())
              .then(result => result);
  },

  removeItem: async function(ids) {    
    console.log(ids);
    await fetch(`${this.updateURL}`, {
                ...this.headers_post,
                body: JSON.stringify({ ...ids, attributes: { 'crating': '' } })
              });
    return;
  },

  count: function(){

    let cartCount = $('.site-header-cart--count');

    if (parseInt(cartCount.data('header-cart-count')) > 0) {

    } else {

    }

  },  
}

// addToCart Button Listener
$('.product-form--atc-button').on('click', async function(){ setTimeout(async () => await Crate.update({action: "no-reload"}), 1000); });
// static cart
$('select.cart-item-qty').on("change", async function(){ setTimeout(async () => await Crate.update({action: "reload"}), 1000); });
$('input.cart-item-qty').on("keyup input", async function(){ setTimeout(async () => await Crate.update({action: "reload"}), 1000); });
$('a.cart-item--remove-link').on("click touch", async function(){ setTimeout(async () => await Crate.update({action: "reload"}), 1000); });

/**
* Crating Checkbox
*/

Shopify.Cart = Shopify.Cart || {};
Shopify.Cart.Crate = {};

Shopify.Cart.Crate.set = function() {
  var headers = new Headers({ 'Content-Type': 'application/json' });

  var request = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ updates: { [window.ciid]: 1 }, attributes: { 'crating': true } })
  };
  fetch('/cart/update.js', request)
  .then(function() {
    location.href = '/cart';
  });
}

Shopify.Cart.Crate.remove = function(param) {
  var headers = new Headers({ 'Content-Type': 'application/json' });
  var value;

  var request = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ updates: { [window.ciid]: 0 }, attributes: { 'crating': '' } })
  };
  fetch('/cart/update.js', request)
  .then(function() {
    location.href = '/cart';
  });
}

// If we have nothing but crate items in the cart.


// When the crating checkbox is checked or unchecked.
document.addEventListener("DOMContentLoaded", function(){
  let crating = document.querySelector('[name="attributes[crating]"]');
  if (crating !== null) {
    crating.addEventListener("click", function(event) {
      // show modal
      $(".modal .modal-close").css({"display": "none"});
      $(".modal .modal-inner").css({"width": "320px", "white-space": "normal"});
      $(".modal .modal-content").html('<h5 class="text-center">Please wait while your cart is updating...</h5>');
      $(".modal").show();
      
      if (event.target.checked) {
        Shopify.Cart.Crate.set();
      } else {
        Shopify.Cart.Crate.remove();
      }
    });
  }
});